export default __webpack_public_path__ + "static/media/helmet.fcbb9e11.svg";